import React from 'react';
import { MathJaxContext } from 'better-react-mathjax';
import './CardScrollerQA.css';
import { renderBlocks } from '../components/renderBlocks'; // ✅ Shared renderer

const CardScrollerQA = ({ items }) => {
  if (!items || items.length === 0) {
    return <div className="text-center text-gray-500 mt-10">No learning content available.</div>;
  }

  return (
    <MathJaxContext>
      <div className="scroller-wrapper">
        {items.map((item, index) => (
          <div key={item.id || index} className="scroller-card">
            <h3 className="card-question text-indigo-700 font-semibold mb-2">
              Q{item.order_index}
            </h3>
            <div className="text-gray-800 text-sm mb-2">
              {item.question_blocks
                ? renderBlocks(item.question_blocks)
                : renderBlocks([{ type: 'text', value: item.question }])
              }
            </div>

            <div className="card-answer text-sm text-gray-700 mt-3">
              <p className="font-bold text-indigo-600 mb-1">Answer:</p>
              {item.answer_blocks
                ? renderBlocks(item.answer_blocks)
                : renderBlocks([{ type: 'text', value: item.answer }])
              }

              {item.hint && (
                <p className="mt-2 text-gray-500 text-sm">
                  <strong>Hint:</strong> {item.hint}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </MathJaxContext>
  );
};

export default CardScrollerQA;
